/* src/app/components/add-user-modal/add-user-modal.component.scss */
.ng-dropdown-footer {
  cursor: pointer;
  padding: 0px;
}
.modal-body .scrollable-dropdown {
  overflow-y: scroll;
  max-height: 60vh;
}
.modal-body .create-new {
  padding: 0.625rem 2.9375rem 0.9375rem 0.875rem;
  cursor: pointer;
}
.modal-body .create-new .ic-add {
  margin-right: 0.625rem;
}
.modal-body .create-new:hover {
  background-color: rgba(114, 114, 127, 0.08);
}
.modal-body .user-info {
  display: flex;
  align-items: center;
  margin-top: 2.25rem;
}
.modal-body .user-info .invite {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: rgba(114, 114, 127, 0.64);
  margin-right: 0.5rem;
}
.modal-body .user-info .dropdown {
  display: flex;
}
.modal-body .user-info .dropdown .btn {
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #155cb4;
}
.modal-body .user-info .dropdown.first {
  margin-right: 3.125rem;
}
.modal-body .user-info .dropdown .dropdown-toggle::after {
  font-family: aof-iconfont;
  content: "\e909";
  font-size: 0.9375rem;
  margin: 0;
  margin-left: 0.1875rem;
  border: 0;
}
.modal-body .user-info .dropdown.show .dropdown-toggle::after {
  content: "\e90c";
}
.custom-checkbox {
  margin-top: 1.875rem;
}
.destination-helper {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin: 0.5rem 0 0 0;
}
.dropdown-item {
  flex-direction: column;
  align-items: flex-start;
}
.dropdown-item .name {
  opacity: 0.64;
}
.dropdown-item .name.active {
  opacity: 1;
  font-weight: 600;
}
.role-button {
  width: 100%;
  height: auto;
  padding: 0.875rem 1rem;
  border-radius: 0;
  background-color: rgba(114, 114, 127, 0.08);
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  box-shadow: none;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #2e2e38;
  background-clip: unset;
  text-align: left;
}
.dropdown-menu {
  width: 100%;
  transform: translate(0, 0) !important;
}
.input-title {
  color: rgba(46, 46, 56, 0.64);
}
.input-title-bott {
  color: rgba(46, 46, 56, 0.64);
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}
/*# sourceMappingURL=add-user-modal.component.css.map */
